import { calculateGridStyles, type Layout } from '../utils/grid-styles';

export interface FieldRenderProps {
  id: string;
  layout: Layout;
  gridStyles: {
    label: React.CSSProperties;
    input: React.CSSProperties;
  };
}

export interface FieldProps {
  id: string;
  layout: Layout;
  children: (props: FieldRenderProps) => React.ReactNode;
}

export function Field(props: FieldProps) {
  const { id, children, layout } = props;

  const gridStyles = calculateGridStyles({
    layout,
  });

  return children({
    id,
    layout,
    gridStyles,
  });
}
